import { tracked } from '@glimmer/tracking';
import BaseController from 'uplisting-frontend/pods/base/controller';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class SidebarBookingsAiController extends BaseController {
  @tracked occasion!:
    | ModelRegistry['booking']
    | ModelRegistry['booking-request']
    | ModelRegistry['enquiry'];
  @tracked occasionType: 'booking' | 'booking-request' | 'enquiry' = 'booking';
}
